import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ILoadProducts, IProduct, Status } from "@shared/interfaces";
import { CountdownConfig } from "ngx-countdown";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { environment } from "src/environments/environment";

const CountdownTimeUnits: Array<[string, number]> = [
    ['Y', 1000 * 60 * 60 * 24 * 365], // years
    ['M', 1000 * 60 * 60 * 24 * 30], // months
    ['D', 1000 * 60 * 60 * 24], // days
    ['H', 1000 * 60 * 60], // hours
    ['m', 1000 * 60], // minutes
    ['s', 1000], // seconds
    ['S', 1], // million seconds
];

@Injectable()
export class ProductsService {
    public readonly DEFAULT_PRODUCT: IProduct = {
        id: 0,
        shop_id: 0,
        category_id: 0,
        shop_name: 'None',
        avatar_url: [],
        avatar_url_preview: [],
        size: null,
        color: null,
        link: '/',
        name: 'None',
        comment_card: 'None',
        desc: 'None',
        price: null,
        discount: null,
        discount_percent: 0,
        time_discount_end: null,
        isAddedToCard: false,
        countdownConfigHour: {},
        is_only_time: null,
        is_from_checkbox: null,
        active_counter: false
    } 
    
    private products$ = new BehaviorSubject<IProduct[]>([]);

    private showTags$ = new BehaviorSubject<boolean>(false);

    private saveScrollState$ = new BehaviorSubject<any>(null);

    constructor(private http: HttpClient) {}

    get products(): IProduct[] {
        return this.products$.value;
    }

    getProducts(): Observable<IProduct[]> {
        return this.products$.asObservable();
    }

    loadProducts(page = 1, count = 50, tag?: number, subtag?: number, sort?: any, search?:string, shop?:number): Observable<ILoadProducts> {
        const url = environment.apiUrl + `/productOffer?page=${page}&active=true&count=${count}${tag?'&tags='+tag:''}${subtag?'&subtags='+subtag:''}${sort?'&order_by='+sort.type+'&type='+sort.order:''}${shop?'&shop_id='+shop:''}${search?'&search='+search:''}`;
        return this.http.get<ILoadProducts>(url);
    }

    loadProductsByShop(page = 1, count = 50, shop?:number): Observable<ILoadProducts> {
        const url = environment.apiUrl + `/productOffer?page=${page}&active=true&count=${count}${shop?'&shop_id='+shop:''}`;
        return this.http.get<ILoadProducts>(url);
    }

    loadHits(page = 1, count = 5): Observable<ILoadProducts> {
        const url = environment.apiUrl + `/productOffer/top?page=${page}&active=true&count=${count}`;
        return this.http.get<ILoadProducts>(url)
    }

    loadTopProducts(page = 1, count = 50): Observable<ILoadProducts> {
        const url = environment.apiUrl + `/productOffer/bestDiscount?page=${page}&active=true&count=${count}`;
        return this.http.get<ILoadProducts>(url)
    }

    searchGlobalProducts(search:string, page = 1, count = 50): Observable<ILoadProducts> {
        const url = environment.apiUrl + `/productOffer?search=${search}&page=${page}&count=${count}`;
        return this.http.get<any>(url)
    }

    loadRecommendedProducts(userId: number): Observable<any> {
        const url = environment.apiUrl + `/user/reccomend/${userId}`;
        return this.http.get<any>(url)
    }

    setProducts(products: IProduct[]) {
        this.products$.next(products);
    }

    addProduct(product: IProduct) {
        this.setProducts([ ...this.products, product ]);
    }

    getProductStatus(status: number) {
        switch(status) {
            case Status.NOT_PAID: return 'Nesumoketas'; 
            case Status.ACCEPTED: return 'Priimtas'; 
            case Status.PART_DELIVERED: return 'Dalinai pristatytas';
            case Status.ISSUED: return 'Išduotas';
            case Status.ORDERED: return 'Uzsakytas';
        }
        return '';
    }

    setCountDownConfig(leftTime: number, format: string) {
        var config: CountdownConfig = {
           leftTime: leftTime * 60 * 60,
           formatDate: ({ date, formatStr }) => {
             let duration = Number(date || 0);
       
             return CountdownTimeUnits.reduce((current, [name, unit]) => {
               if (current.indexOf(name) !== -1) {
                 const v = Math.floor(duration / unit);
                 duration -= v * unit;
                 return current.replace(new RegExp(`${name}+`, 'g'), (match: string) => {
                   return v.toString().padStart(match.length, '0');
                 });
               }
               return current;
             }, format);
           },
         };
        return config;
    }

    getProductsRandom(tags?: any, id?: 1): Observable<any> {
        if (tags && tags.length != 0) {
            let tgs: any = [];
            tags.forEach((tag: any) => {
                tgs.push(tag.id);
            });
            tags = '&tags=' + tgs.join(',');
        }
        const url = environment.apiUrl + `/productOfferRandom?active=true${tags}&count=6&id=${id}`;
        return this.http.get(url);
    }

    getTags(): Observable<any> {
        const url = environment.apiUrl + `/tags?count=20`;
        return this.http.get(url);
    }

    getAllDeliveryData(): Observable<any> {
        const url = environment.apiUrl + `/all-delivery-data`;
        return this.http.get(url);
    }

    sortTags(tags: any[]): any[] {
      let sortTags: any = [];
      tags.forEach(tag => {
        if(tag.id == 50) {
            sortTags[0] = tag;
        }else if(tag.id == 43) {
            sortTags[1] = tag;
        }else if(tag.id == 52) {
            sortTags[2] = tag;
        }else if(tag.id == 131) {
            sortTags[3] = tag;
        }else if(tag.id == 127) {
            sortTags[4] = tag;
        }else if(tag.id == 132) {
            sortTags[5] = tag;
        }else if(tag.id == 47) {
            sortTags[6] = tag;
        }else if(tag.id == 49) {
            sortTags[7] = tag;
        }else if(tag.id == 48) {
            sortTags[8] = tag;
        }else if(tag.id == 46) {
            sortTags[9] = tag;
        }else if(tag.id == 67) {
            sortTags[10] = tag;
        }else if(tag.id == 44) {
            sortTags[11] = tag;
        }else if(tag.id == 51) {
            sortTags[12] = tag;
        }
      })
      return sortTags;
    }

    getSingleProduct(id:number): Observable<any> {
        const url = environment.apiUrl + `/productOffers/${id}`;
        return this.http.get(url);
    }

    private basketCount$ = new BehaviorSubject<number>(0);

    getBasketCount(): Observable<number> {
        return this.basketCount$.asObservable();
    }

    getBasketCurrentCount(){
        return this.basketCount$.getValue();
    }

    setBasketCount(count:number) {
        this.basketCount$.next(count);
    }

    getBasket(): Observable<any> {
        const url = environment.apiUrl + `/user/bascket`;
        return this.http.get(url);
    }

    setBasket(id:any, body:any): Observable<any> {
        const url = environment.apiUrl + `/user/bascket/${id}`;
        return this.http.post(url, body)
    }

    editBasket(id:any, body:any): Observable<any> {
        const url = environment.apiUrl + `/user/bascketProduct/${id}`;
        return this.http.post(url, body)
    }

    removeBascketItem(id:number): Observable<any>{
        const url = environment.apiUrl + `/user/bascket/${id}`;
        return this.http.delete(url);
    }

    clearBasket(): Observable<any>{
        const url = environment.apiUrl + `/user/bascket`;
        return this.http.delete(url);
    }

    orderBasket(): Observable<any>{
        const url = environment.apiUrl + `/user/bascketbuy`;
        return this.http.post(url, {});
    }

    checkBasket(): Observable<any>{
        const url = environment.apiUrl + `/user/bascketCheck`;
        return this.http.get(url);
    }

    isShowTagsOnMobile(): Observable<boolean> {
        return this.showTags$.asObservable();
    }

    showTagsOnPhone(showTags: boolean) {
        this.showTags$.next(showTags);
    }

    getScrollState(): Observable<any> {
        return this.saveScrollState$.asObservable();
      }
    
    setScrollState(value: 
            {
                page: any,  
                scrollPosition: any, 
                total: any, 
                currentProductsCount: any,
                products: IProduct[]
            } | null) 
    {
        this.saveScrollState$.next(value);
    }
}